<div class="d-flex flex-column justify-content-center dialog-container">
  <div class="d-flex justify-content-end" >
    <img class="cursor-pointer" [src]="'assets/svg-icons/close.svg'" alt="" (click)="dialogRef.close()" data-cy="confirmation-no"/>
  </div>
  <div class="d-flex flex-column justify-content-center gap-1 ps-4 pe-4">
    <span class="d-flex title justify-content-center">{{'account.menu.skendata.dialog.title'|translate}}</span>
    <span class="d-flex"><b>{{'account.menu.skendata.dialog.subtitle'|translate}}</b><br/><br/></span>
    <div class="scrollable-content ">
    <div class="justify-content-center">
      <span class="body-text">{{'account.menu.skendata.dialog.body_paragraph1'|translate}}</span><br/><br/>
      <span class="body-text">{{'account.menu.skendata.dialog.body_paragraph2_1'|translate}}</span>
      <span class="body-text"><b>{{'account.menu.skendata.dialog.body_paragraph2_percent'|translate}}</b></span>
      <span class="body-text">{{'account.menu.skendata.dialog.body_paragraph2_2'|translate}}</span>
    </div>
    <div class="body-text-wrapper">
      <img class="mr-1 align-content-center" src="assets/svg-icons/circle-actions-alert-info.svg" alt="">
      <span class="body-text"><b>{{'account.menu.skendata.dialog.boxedContent'|translate}}</b></span>
      <ul>
        <li>{{'account.menu.skendata.dialog.boxedContent_1'|translate}}</li>
        <li>{{'account.menu.skendata.dialog.boxedContent_2'|translate}}</li>
        <li>{{'account.menu.skendata.dialog.boxedContent_3'|translate}}</li>
        <li>{{'account.menu.skendata.dialog.boxedContent_4'|translate}}</li>
        <li>{{'account.menu.skendata.dialog.boxedContent_5'|translate}}</li>
      </ul>
    </div>
  </div>
  </div>

  <div class="d-flex ps-4 pe-4 gap-2 w-100">
    <button class="close-button" (click)="dialogRef.close()" data-cy="confirmation-no">{{'account.menu.skendata.dialog.cancelButton'|translate}}</button>
    <button class="confirm-button" [mat-dialog-close]="true" cdkFocusInitial data-cy="confirmation-yes">{{'account.menu.skendata.dialog.confirmButton'|translate}}</button>
  </div>
</div>

